
















import { XKZ_RADAR_COLOR_GROUP } from '@/utils/constants'
import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      XKZ_RADAR_COLOR_GROUP: XKZ_RADAR_COLOR_GROUP
    }
  }
})
